export const initialState = {
  healthConditions: []
};
